module.exports = __webpack_public_path__ + "static/media/tech.241d1434.jpg";